import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import {
  InspectedByRove,
  FastWifi,
  ExceptionalProperties,
  PremiumAmenities,
  PreferredLocations,
} from '@assets/icons/rove-promise';

import styles from './styles.module.scss';

RovePromise.defaultProps = {};

export function RovePromise(props: BaseComponentProps) {
  const { containerStyle } = props;

  return (
    <div className={clsx([styles.rovePromise, containerStyle])}>
      <h4>THE ROVE PROMISE</h4>

      <div className={styles.description}>
        Like all other listings on Rove, this property features Rove’s core
        tenets.
      </div>

      <div className={styles.list}>
        <div>
          <InspectedByRove />
          <span>Inspected by Rove’s Team</span>
        </div>

        <div>
          <FastWifi />
          <span>Fast Wifi</span>
        </div>

        <div>
          <ExceptionalProperties />
          <span>Exceptional Properties</span>
        </div>

        <div>
          <PremiumAmenities />
          <span>Premium Amenities</span>
        </div>

        <div>
          <PreferredLocations />
          <span>Preferred Locations</span>
        </div>
      </div>
    </div>
  );
}
